export const ZONE_DEFAULT_FILTERS = { archived: false, risk: undefined };
